import { Box, tabNavigationStyle, Text } from '@lojinha/design-system'
import { testId } from '@lojinha/helpers'
import React, { FC } from 'react'
import styled from 'styled-components'
import { t } from '../../dictionary'
import { DayCalendar } from '../../components/day-calendar'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${tabNavigationStyle};
`

type CalendarHeaderProps = {
  title: string
  details: string[]
  detailsAriaLabel: string[]
  dayNumber: number
}

export const CalendarHeader: FC<CalendarHeaderProps> = ({
  title,
  details,
  detailsAriaLabel,
  dayNumber,
}) => {
  const ariaLabelText = `${t.detailsAbout} ${title} ${t.detailsDay} ${dayNumber}: ${detailsAriaLabel}`
  return (
    <Box display="flex">
      <Box
        display="flex"
        paddingRight="x16"
        htmlAttrs={{
          style: {
            alignSelf: 'center',
            alignItems: 'center',
            justifyContent: 'center',
          },
        }}
        {...testId('calendar-header-day-calendar')}
      >
        <DayCalendar dayNumber={dayNumber} />
      </Box>

      <Wrapper aria-label={ariaLabelText} tabIndex={0}>
        <Text isBold textSize="x2" {...testId('calendar-header-title')}>
          {title}
        </Text>

        <Box>
          {!!details.length && (
            <Text
              textSize="x2"
              as="span"
              {...testId('calendar-header-details')}
              aria-label={ariaLabelText}
            >
              {details.join(' · ')}
            </Text>
          )}
        </Box>
      </Wrapper>
    </Box>
  )
}
